<template>
  <div class="col">
    <div ref="rules" class="col-claim rules">
      <div class="wrap">
        <h1 class="claim-headline">zasady gry</h1>
        <span class="claim-headline-span"></span>
        <div class="claim-paragraph" v-html="gameRulesContent"></div>
      </div>
      <div class="action-bar">
        <button class="btn btn-green" id="gameRules" @click="eventAccepted()"><span>ROZUMIEM</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MoleculesMissionName from "@/molecules/MoleculeMissionName";
import {rules, TimelineLite} from "gsap";

export default {
name: "OrganismGameRules",
  data(){
    return{
      gameRulesContent: null,
      gamenameGTM:'',
    }
  },
  components:{ MoleculesMissionName },
  computed: {
    ...mapGetters(['setupGame','hangmanGame','memoryGame','shopGame']),
  },
  methods: {
    ...mapActions(['setGameRole','audioPlayer','stopAudio']),

    eventAccepted(){
      if (this.setupGame.gameType == 1){
        this.gamenameGTM = "Pieniądze od podszewki"
      }else if(this.setupGame.gameType == 2){
        this.gamenameGTM = "Misja bezpieczeństwo"
      }else if(this.setupGame.gameType == 3){
        this.gamenameGTM = "Zarządzam budżetem"
      }
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - ROZUMIEM",
        label: this.gamenameGTM + ": Zasady gry",  //  gameType
      })
      this.setGameRole()
      this.stopAudio()
      this.audioPlayer({
        'url': [
          '/intro/select_game_level.mp3'
        ],
      })
    }
  },
  mounted() {
    if (this.setupGame.gameType == 1){
      this.gameRulesContent = this.hangmanGame.gameRules;
    }else if(this.setupGame.gameType == 2){
      this.gameRulesContent = this.memoryGame.gameRules;
    }else{
      this.gameRulesContent = this.shopGame.gameRules;
    }

  }
}
</script>
